import axios from 'axios';

let apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

// Ensure URL ends with /api
if (import.meta.env.VITE_API_URL && !apiUrl.endsWith('/api')) {
  apiUrl = `${apiUrl.replace(/\/$/, '')}/api`;
}

console.log('🔌 [Debug] VITE_API_URL env var:', import.meta.env.VITE_API_URL);
console.log('🔌 [Debug] Final API Base URL:', apiUrl);

const api = axios.create({
  baseURL: apiUrl,
});

// Interceptor para adicionar token JWT em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Metrics endpoints
export const getOccupationMetrics = () => api.get('/metrics/occupation');
export const getCleaningSLA = () => api.get('/metrics/cleaning-sla');
export const getBedReleaseTime = () => api.get('/metrics/bed-release-time');
export const getCleaningPerformance = () => api.get('/metrics/cleaning-performance');
export const getFlowEfficiency = () => api.get('/metrics/flow-efficiency');

// Bed endpoints
export const getBeds = () => api.get('/beds');

export const getBedById = (id) => api.get(`/beds/${id}`);
export const getBedTimeline = (bedId) => api.get(`/beds/${bedId}/timeline`);

export const updateBedStatus = (id, statusId, notes) =>
  api.patch(`/beds/${id}/status`, { statusId, notes });

export const updateBed = (id, bed) => api.put(`/beds/${id}`, bed);

export const createBed = (bed) => api.post('/beds', bed);

export const deleteBed = (id) => api.delete(`/beds/${id}`);

export const getBedHistory = (id) => api.get(`/beds/${id}/history`);

export const bulkUpdateBeds = (updates) => api.post('/beds/bulk-update', { updates });

export const searchBeds = (filters) => api.get('/beds/search', { params: filters });

// Status endpoints
export const getStatuses = () => api.get('/statuses');

export const createStatus = (status) => api.post('/statuses', status);

export const updateStatus = (id, status) => api.put(`/statuses/${id}`, status);

export const deleteStatus = (id) => api.delete(`/statuses/${id}`);

// Sector endpoints
export const getSectors = () => api.get('/sectors');

export const createSector = (sector) => api.post('/sectors', sector);

export const updateSector = (id, sector) => api.put(`/sectors/${id}`, sector);

export const deleteSector = (id) => api.delete(`/sectors/${id}`);

// Audit Log endpoints
export const getAuditLogs = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.actionType) params.append('action_type', filters.actionType);
  if (filters.dateFrom) params.append('date_from', filters.dateFrom);
  if (filters.dateTo) params.append('date_to', filters.dateTo);
  if (filters.tableName) params.append('table_name', filters.tableName);
  if (filters.userId) params.append('user_id', filters.userId);
  if (filters.limit) params.append('limit', filters.limit);

  return api.get(`/audit-logs?${params.toString()}`);
};

export const getAuditLogById = (id) => api.get(`/audit-logs/${id}`);

export default api;

